import { render, staticRenderFns } from "./Cake.vue?vue&type=template&id=00aac3e0"
import script from "./Cake.vue?vue&type=script&lang=js"
export * from "./Cake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports